import React from "react";
import PropTypes from "prop-types";

function FlashIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="40"
      viewBox="0 0 26 40"
      style={{ width: "auto", height: "auto" }}
    >
      <g fill="none" fillRule="evenodd" strokeLinejoin="round">
        <g fill="#FB6E00" fillRule="nonzero" stroke="#17181A" strokeWidth="2">
          <g>
            <g>
              <g>
                <g>
                  <g>
                    <path
                      d="M43.198-5.224L35.48 14h7.718c.385.002.755.1 1.08.274l.16.093c.364.234.661.568.85.976.188.408.25.852.19 1.28-.058.427-.237.838-.531 1.184h0l-20.142 23.42L32.523 22h-7.715c-.386 0-.757-.097-1.084-.271l-.16-.094c-.365-.234-.664-.57-.852-.978-.19-.41-.25-.855-.19-1.284.06-.429.24-.84.535-1.183h0l20.14-23.414z"
                      transform="translate(-1312 -1043) translate(1083) translate(34 727) translate(22 29) translate(126 206) translate(26 83)"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

FlashIcon.propTypes = {};

export default FlashIcon;
